/* eslint-disable no-unused-vars */
// FilterDepartmentOneSelect.js
import React from "react";
import { PatchedSelect } from "./selectDropdownPatch";
import "./selectDropdownPatch.css";

export default function FilterDepartmentOneSelect({
  data,
  filters,
  userData,
  handleEvents }) {
  // ✅ countries
  const countries =
    Array.isArray(filters.country) && filters.country.length > 0
      ? filters.country
      : Object.keys((data && data.departments) || {});

  // ✅ departments
  const departments = [];
  (countries || []).forEach((cc) => {
    const list = (data.departments && data.departments[cc]) || [];
    list.forEach((d) => departments.push(d));
  });

  // ✅ เตรียม choices
  const choices = departments
    .slice()
    .sort((a, b) => (a.dept_name || "").localeCompare(b.dept_name || ""))
    .map((dept) => ({
      key: `D:${dept.dept_id}`,
      value: String(dept.dept_id),
      text: dept.dept_name || String(dept.dept_id) }));

  // ✅ filter ค่า department ที่เลือกแล้ว
  const visibleOptionIds = new Set(choices.map((c) => c.value));

  let selected = Array.isArray(filters.department)
    ? filters.department.map(String)
    : [];

  let valueForSelect = selected.filter((id) => visibleOptionIds.has(id));

  const onChangeDepartments = (e) => {
    const values = Array.from(e.target.selectedOptions, (o) => o.value);

    // ✅ update parent state เฉพาะ department
    handleEvents.OnChange({
      target: { name: "department", value: values, type: "select-multiple" } });
  };

  const disabled = choices.length === 0;
  const selectId = "filter-inp-department";

  return (
    <div
      className="filter-input-field select"
      key="filter-department-one-select"
    >
      <PatchedSelect
        multiple
        id={selectId}
        name="department"
        value={valueForSelect}
        onChange={onChangeDepartments}
        patchOptions={{
          labelClass: "option-label",
          clearActive: true }}
        options={{
          dropdownOptions: {
            alignment: "left",
            autoTrigger: true,
            closeOnClick: false,
            constrainWidth: true,
            coverTrigger: true,
            hover: false,
            inDuration: 150,
            outDuration: 250 } }}
      >
        {/* ✅ placeholder option */}
        <option value="" disabled>
          Department
        </option>

        {choices.map((ch) => (
          <option key={ch.key} value={ch.value}>
            {ch.text}
          </option>
        ))}
      </PatchedSelect>

      {/* <span
        className="select-helper-text helper-text"
        id="helper-text-department"
      >
        {disabled
          ? "No Department available for the selected country"
          : "You can select multiple Departments (hold Ctrl/Cmd to multi-select)"}
      </span> */}
    </div>
  );
}

